// extracted by mini-css-extract-plugin
export default {"wrapper":"FileInput_wrapper__Y7fJw","iconWrapper":"FileInput_iconWrapper__RhUeb"};